<div v-if="shouldRenderConfig" v-bind:class="getClassName">
    <div v-if="getWebProductEnableTemplateChooser">
        <Select2
            v-model="value"
            :options="options"
            :settings="settings"
        />        
    </div>
    <button type="button" class="btn btn-primary" ref="personalizeBtn" v-bind:class="getDisableClass" v-on:click="onClickPersonalize()">
        <img :class="getClassName + 'Icon'" :src="this.getBaseUrl + '/images/matrix/create_artwork.png'"/>
        <span>{{ $t('Personalize') }}</span>
    </button>    
</div>

